export enum UrlStatus {
  Redirected = 'REDIRECTED',
  RedirectedTemporary = 'REDIRECTED_TEMPORARY',
}
